<template>
	<div>
		<b-form-radio-group
			:state="state"
			:class="{ radioColumn: field.columnDirection }"
			:options="radios"
			v-model="proxyValue"
			:value-field="field.valueField ? field.valueField : 'value'"
			:text-field="field.textField ? field.textField : 'text'"
			@change="onChange"
			:disabled="field.disabled != null && field.disabled != null ? field.disabled : !active"
		>
		</b-form-radio-group>

		<b-form-invalid-feedback
			:id="`${name}-feedback`"
			:state="state"
			v-if="field.disabled != null && field.disabled != null ? !field.disabled : active"
		>
			{{ errors[name] }}
		</b-form-invalid-feedback>
	</div>
</template>

<script>
export default {
	props: {
		radios: {
			type: Array,
			required: true
		},
		data: {
			type: Array
		},
		selected: {
			type: [String, Number, Boolean]
		},
		tblItems: {
			type: Array
		},
		isActive: {
			type: [Boolean, Function],
			required: true
		},
		name: {
			type: String
		},
		state: {
			type: Boolean
		},
		errors: {
			type: Object
		},
		field: {
			type: Object
		}
	},

	computed: {
		proxyValue: {
			get() {
				return this.selected;
			},
			set(newValue) {
				this.$emit("input", newValue);
				this.$emit("onChange", this.name);
			}
		}
	},

	methods: {
		onChange: function () {
			this.$emit("onChange", this.name);
		},
		parentChanged: function (parentValue) {
			if (typeof this.isActive == "function") {
				this.active = this.isActive(parentValue);
			}
		}
	},
	data() {
		return {
			active: true
		};
	},
	beforeMount() {
		this.active = typeof this.isActive == "function" ? this.isActive(null) : this.isActive;
	}
};
</script>

<style>
.radioColumn {
	display: flex;
	flex-direction: column;
}
</style>
